"use client";

import { m } from "framer-motion";
import AnimatedSection from "./AnimatedSection";
import SectionHeader from "./SectionHeader";

const TECHNOLOGIES = [
  { name: "React", color: "#61DAFB" },
  { name: "Next.js", color: "#FFFFFF" },
  { name: "TypeScript", color: "#3178C6" },
  { name: "Tailwind CSS", color: "#06B6D4" },
  { name: "Node.js", color: "#339933" },
  { name: "Firebase", color: "#FFCA28" },
  { name: "Three.js", color: "#FFFFFF" },
  { name: "Framer Motion", color: "#FF0055" },
  { name: "Vercel", color: "#FFFFFF" },
  { name: "Capacitor", color: "#53B9FF" },
  { name: "Supabase", color: "#3ECF8E" },
  { name: "Git", color: "#F05032" },
];

const TechStack = () => {
  return (
    <section id="tech" className="relative px-4 py-24">
      <div className="section-divider mx-auto mb-20 max-w-xl" />

      <div className="mx-auto max-w-6xl">
        <SectionHeader
          index="06"
          code="toolkit"
          align="left"
          title={<>What I <span className="gradient-text">use</span></>}
          blurb="These are the tools I reach for when I’m building. Not because they’re trendy — because they work."
        />

        <div className="grid grid-cols-3 gap-4 md:grid-cols-4 lg:grid-cols-6">
          {TECHNOLOGIES.map((tech, index) => (
            <AnimatedSection key={tech.name} delay={index * 0.05}>
              <m.div
                whileHover={{
                  scale: 1.08,
                  boxShadow: `0 0 20px ${tech.color}15`,
                }}
                className="glass-card flex flex-col items-center justify-center gap-3 rounded-xl p-6 text-center"
              >
                <span
                  className="font-[family-name:var(--font-jetbrains-mono)] text-xs font-medium"
                  style={{ color: tech.color }}
                >
                  {tech.name}
                </span>
              </m.div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
